import { NodeTranslationsClient } from '@meltwater/node-translations-client';

export * from './translation-keys';

const languagePromises = new Map();

async function initializeTranslations(language) {
    const initPromise = await new NodeTranslationsClient({
        currentLanguage: language,
        fallbackLanguage: 'en',
        fallbackTranslations: require('./en.json'),
        manifest: 'pr-document-visualizations'
    });

    languagePromises.set(language, initPromise);
}

export async function getTranslations({ language }) {
    if (!languagePromises.has(language)) {
        await initializeTranslations(language);
    }

    const translations = await languagePromises.get(language);

    return translations.getTranslations();
}

export function __clearInstanceForTestingUseOnly() {
    languagePromises.clear();
}
